import { z } from 'zod'

export const ConfigurationEnabledAutomationTestRegionZod = z.object({
  value: z.boolean().optional().default(false),
})
